import { render, staticRenderFns } from "./UserMgt.vue?vue&type=template&id=4c4643f8&scoped=true&"
import script from "./UserMgt.vue?vue&type=script&lang=js&"
export * from "./UserMgt.vue?vue&type=script&lang=js&"
import style0 from "./UserMgt.vue?vue&type=style&index=0&id=4c4643f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4643f8",
  null
  
)

export default component.exports